import Vue from 'vue'
import consolidatedSupplies from '@/transformers/purchase/consolidatedSupplies'

/**
 * @author Mariela Temozihui Tlahuel <mariela.temozihui@jbge.com.mx>
 *
 * list consolidated for quotation
 * January 2024 petition by highway instead camp
 */

const fetchConsolidated = (warehouseId) =>
  Vue.$http.get(`purchase/consolidated-for-quotation/?iwarehouse=${warehouseId}`)
    .then(response => {
      return consolidatedSupplies.fetchCollection(response.data)
    })
    .catch(err => {
      throw err
    })

export default fetchConsolidated


// WEBPACK FOOTER //
// ./src/services/purchase/quotation/fetchConsolidatedQuotation.js